var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-satnik", {
        attrs: {
          kravicka: _vm.kravicka,
          activeCategory: _vm.filterSatnikKategoriaTyp
        },
        on: { showProducts: _vm.showProducts }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid pl-0 pr-0" }, [
        _c(
          "div",
          { staticClass: "row no-gutters" },
          [
            _c("div", { staticClass: "col-lg-6 col-xl-6" }, [
              _c(
                "section",
                {
                  staticClass: "shopProducts --lightBg",
                  class: { open: _vm.showShopProducts }
                },
                [
                  _c("div", { staticClass: "shopHeader --whiteBg d-flex" }, [
                    _c("h2", { staticClass: "mb-0" }, [_vm._v("Šatník")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "shopHeader__right" }, [
                      _c(
                        "span",
                        {
                          staticClass: "takeOff d-none d-md-inline-block",
                          on: { click: _vm.vyzliectKravicku }
                        },
                        [
                          _c("span", { staticClass: "icon" }),
                          _vm._v(
                            "Vyzliecť kravičku\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "takeOffButton btn --secondary d-md-none",
                          on: { click: _vm.vyzliectKravicku }
                        },
                        [_c("span", { staticClass: "icon" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "downloadButton btn --primary",
                          on: { click: _vm.printScreen }
                        },
                        [
                          _vm.showLoader
                            ? _c("span", {
                                staticClass: "icon --loader fa-spin"
                              })
                            : _c("span", { staticClass: "icon" })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "fbButton btn --facebookNormal",
                          on: { click: _vm.fbShare }
                        },
                        [_c("span", { staticClass: "icon" })]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.responseText != ""
                    ? _c(
                        "div",
                        {
                          class:
                            "alert alert-dismissible fade show --shopAlert alert-" +
                            _vm.responseType,
                          attrs: { role: "alert" }
                        },
                        [
                          _c("p", { staticClass: "mb-0" }, [
                            _c("span", { class: "icon --" + _vm.responseType }),
                            _vm._v(
                              _vm._s(_vm.responseText) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: {
                                type: "button",
                                "data-dismiss": "alert",
                                "aria-label": "Close"
                              },
                              on: {
                                click: function($event) {
                                  _vm.responseText = ""
                                }
                              }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "o-dressingRoom__products" }, [
                    _c("div", { staticClass: "dressingRoom__header d-flex" }, [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.filterSatnikKategoriaNazov))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "dressingRoom__filter" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "--likeLink d-none d-md-inline-block pl-0",
                            class: {
                              "--active": _vm.filterSatnikProduktStav === "all"
                            },
                            on: {
                              click: function($event) {
                                _vm.filterSatnikProduktStav = "all"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    Všetky\n                                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "--likeLink d-none d-md-inline-block",
                            class: {
                              "--active":
                                _vm.filterSatnikProduktStav === "kupene"
                            },
                            on: {
                              click: function($event) {
                                _vm.filterSatnikProduktStav = "kupene"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    Zakúpené\n                                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "--likeLink d-none d-md-inline-block pr-0",
                            class: {
                              "--active":
                                _vm.filterSatnikProduktStav === "nekupene"
                            },
                            on: {
                              click: function($event) {
                                _vm.filterSatnikProduktStav = "nekupene"
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                    Nezakúpené\n                                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterSatnikProduktStav,
                                expression: "filterSatnikProduktStav"
                              }
                            ],
                            staticClass: "custom-select d-md-none",
                            attrs: { id: "inputGroupSelect01" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.filterSatnikProduktStav = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "all" } }, [
                              _vm._v("Všetky")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "kupene" } }, [
                              _vm._v("Zakúpené")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "nekupene" } }, [
                              _vm._v("Nezakúpené")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "o-productGrid" }, [
                      _vm.satnik.length > 0
                        ? _c(
                            "div",
                            { staticClass: "m-productGrid__list --small" },
                            [
                              _vm._l(
                                _vm.satnik.filter(_vm.filterSatnikProdukty),
                                function(produkt, index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "a-productGrid__item mb-2 --small",
                                        class: {
                                          "--dressed": produkt.active === 1,
                                          "--bought":
                                            produkt.active === 0 &&
                                            produkt.disabled === 1
                                        },
                                        style: "z-index:" + [100 - index]
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "productGridItem_content"
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "img-fluid",
                                              attrs: {
                                                src:
                                                  "assets/img/satnik-icons/" +
                                                  produkt.satnik_produkt_ikona,
                                                alt: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "productGridItem__title"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    produkt.satnik_produkt_meno
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            produkt.disabled === 1
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "productGridItem__alreadyBought"
                                                  },
                                                  [_vm._v("Zakúpené")]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "productGridItem__price"
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon"
                                                    }),
                                                    _vm._v(
                                                      _vm._s(
                                                        produkt.satnik_produkt_cena
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        produkt.satnik_produkt_novinka === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "productGridItem__new__tag"
                                              },
                                              [_vm._v("Nové")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        produkt.active === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "productGridItem__applied"
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "icon"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        produkt.disabled === 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "productGridItem__button"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.buySatnikProduct(
                                                          _vm.satnik.indexOf(
                                                            produkt
                                                          ),
                                                          produkt
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon"
                                                    }),
                                                    _vm._v(
                                                      "Kúpiť\n                                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        produkt.active === 0 &&
                                        produkt.disabled === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "productGridItem__button"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.useSatnikProduct(
                                                          _vm.satnik.indexOf(
                                                            produkt
                                                          ),
                                                          produkt
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon"
                                                    }),
                                                    _vm._v(
                                                      "Obliecť\n                                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        produkt.active === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "productGridItem__button"
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "btn",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.hideSatnikProduct(
                                                          _vm.satnik.indexOf(
                                                            produkt
                                                          ),
                                                          produkt
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "icon"
                                                    }),
                                                    _vm._v(
                                                      "Vyzliecť\n                                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                }
                              )
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn --primary d-md-none",
                      attrs: { id: "closeShopMenu" },
                      on: {
                        click: function($event) {
                          _vm.showShopProducts = false
                        }
                      }
                    },
                    [_c("span", { staticClass: "icon" })]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 col-xl-6" }, [
              _c(
                "section",
                {
                  ref: "contentWrapper",
                  staticClass: "shopCowPreview --lightBg"
                },
                [
                  _c("div", { staticClass: "shopCowPreview__cow" }, [
                    _c("div", { staticClass: "shopCowPreview__imageWrap" }, [
                      _c("img", {
                        attrs: {
                          src: "assets/img/satnik/AK_Standing.png",
                          alt: "",
                          height: "800"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "shopCowPreview__dressWrap" },
                        [
                          _vm._l(_vm.satnik, function(produkt) {
                            return [
                              produkt.satnik_produkt_povoleny === "1"
                                ? _c("img", {
                                    class: { "--hidden": !produkt.active },
                                    style: {
                                      "z-index": _vm.getProduktZIndex(produkt)
                                    },
                                    attrs: {
                                      src:
                                        "assets/img/satnik/" +
                                        produkt.satnik_produkt_img,
                                      alt: "",
                                      height: "800"
                                    }
                                  })
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("header-satnik", {
              attrs: { profil: _vm.profil },
              on: { updateProfil: _vm.emitUpdateProfil }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }